webpackJsonp([35783957827783],{

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/chiclogo.b74ad1f8.png";

/***/ }),

/***/ 93:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ButtonSecondary = undefined;
	
	var _reactEmotion = __webpack_require__(8);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var colors = {
	  primary: 'black',
	  secondary: 'rgba(0, 96, 193, 0.25)'
	};
	
	var buttonBasic = /*#__PURE__*/(0, _reactEmotion.css)('width:100%;padding:0.5rem 1.25rem;border-radius:5px;border:2px solid ', colors.secondary, ';');
	
	var buttonPrimary = /*#__PURE__*/(0, _reactEmotion.css)(buttonBasic, ';background-color:', colors.secondary, ';color:', colors.primary, ';transition:all 0.3s ease;&:hover{background-color:transparent;color:', colors.secondary, ';cursor:pointer;}');
	
	var buttonSecondary = /*#__PURE__*/(0, _reactEmotion.css)(buttonBasic, ';background-color:transparent;color:', colors.secondary, ';transition:all 0.3s ease;&:hover{background-color:', colors.secondary, ';color:', colors.primary, ';cursor:pointer;}');
	
	var ButtonPrimary = /*#__PURE__*/(0, _reactEmotion2.default)('button', {
	  target: 'css-lh7e160'
	})(buttonPrimary, ';');
	
	var ButtonSecondary = /*#__PURE__*/exports.ButtonSecondary = (0, _reactEmotion2.default)('button', {
	  target: 'css-lh7e161'
	})(buttonSecondary, ';');
	
	exports.default = ButtonPrimary;

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Misc = __webpack_require__(19);
	
	var _Layout = __webpack_require__(14);
	
	var _Buttons = __webpack_require__(93);
	
	var _Buttons2 = _interopRequireDefault(_Buttons);
	
	var _ribbonModule = __webpack_require__(36);
	
	var _ribbonModule2 = _interopRequireDefault(_ribbonModule);
	
	var _Footer = __webpack_require__(18);
	
	var _chiclogo = __webpack_require__(343);
	
	var _chiclogo2 = _interopRequireDefault(_chiclogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var iformStyle = {
	  background: 'transparent',
	  border: '1px solid #ccc'
	}; /* eslint-disable */
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var myData = data.allContentJson.edges[0].node.index;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Layout.Box,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: _ribbonModule2.default.cornerRibbon },
	        'Beta'
	      ),
	      _react2.default.createElement(
	        _Layout.Box,
	        {
	          width: [1, 1, 1 / 2],
	          m: ['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto'],
	          px: [3, 3, 0],
	          align: 'center'
	        },
	        _react2.default.createElement(
	          'h1',
	          null,
	          myData.title
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          myData.subtitle
	        ),
	        _react2.default.createElement('img', {
	          src: _chiclogo2.default,
	          style: {
	            marginLeft: '4rem',
	            marginBottom: '2rem',
	            marginTop: '2rem',
	            marginRight: '4rem',
	            width: '7rem',
	            height: 'auto'
	          },
	          alt: ''
	        }),
	        _react2.default.createElement(
	          _Layout.Flex,
	          { justify: 'center', wrap: ['wrap', 'wrap', 'nowrap'] },
	          _react2.default.createElement(
	            _Layout.Box,
	            { m: [1], width: [1, 1 / 2, 1 / 2] },
	            _react2.default.createElement(
	              _Misc.PlainLink,
	              { to: '/Institutions' },
	              _react2.default.createElement(
	                _Buttons2.default,
	                null,
	                'Participating Institutions'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _Layout.Box,
	            { m: [1], width: [1, 1 / 2, 1 / 2] },
	            _react2.default.createElement(
	              _Misc.PlainLink,
	              { to: '/modules' },
	              _react2.default.createElement(
	                _Buttons.ButtonSecondary,
	                null,
	                'Browse all Modules'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Layout.Box,
	      { py: [3, 3, 4] },
	      _react2.default.createElement(
	        _Layout.Box,
	        { width: [1, 1, 1 / 2], m: '0 auto', px: [3, 3, 0] },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Welcome!'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'You are on the open coursework platform of the ',
	          _react2.default.createElement(
	            _Misc.ExtLink,
	            { to: 'https://chi.camp/' },
	            'China Hardware Innovation Camp (CHIC)'
	          ),
	          '. This portal is aimed at coordinators, teachers and supervisors of academic institutions who would like to introduce or are currently offering the CHIC program to their students. Likewise, if you would like to pick up elements of the curriculum in your company or as an independent program, you will find here the necessary resources.'
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          'For coordinators'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If you would like to sign up your institution to the CHIC program, please use the form below. Your institution will, after completion, be listed under the participating Institutions. From there, you will find your custom course selection and a typical timeline for the program.'
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          'For teacher and supervisors'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Go directly to the ',
	          _react2.default.createElement(
	            _Misc.Link,
	            { to: '/institutions' },
	            'Participating Institutions'
	          ),
	          ' page in order to prepare upcoming teaching units and download background and support material.'
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          'For students and independent teams'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If you are affiliated to an acedemic institution, talk with your teachers or program coordinators about CHIC and open.CHIC in order to officially onboard your school to the program. You will get access to the resources through your teachers.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'If you would rather like to run an independent version of CHIC as a team, you may also use the form below.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'As an independent learner, you may ',
	          _react2.default.createElement(
	            _Misc.Link,
	            { to: '/modules' },
	            'browse all modules'
	          ),
	          ' in order to help you design and develop a connected device with the CHIC approach.'
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Start your own CHIC'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Sign up your team or institution with the following form and we will get back to you shortly with an individual program suggestion.'
	        ),
	        _react2.default.createElement('iframe', {
	          title: 'airtable_form',
	          className: 'airtable-embed',
	          src: 'https://airtable.com/embed/shrScXa2NPnHCKU23?backgroundColor=blue',
	          frameBorder: '0',
	          onmousewheel: '',
	          width: '100%',
	          height: '533',
	          style: iformStyle
	        })
	      )
	    ),
	    _react2.default.createElement(_Footer.Footer, null)
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-1ad03aa09899aa38ee99.js